import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOne = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.378 12.506V10.28H17.256V20.5H14.764V12.506H13.378Z" })
});
export { SvgOne as ReactComponent };
